<template>
    <ModalError @cerrar="cerrarModalError" v-if="showModalError" :mensaje="mensajeError" />
  <Modal
  v-else
    cuerpoModal="overflow"
    @closeModal="handleCerrar"
    :showMovilHeader="true"
    :fit="true"
    :showHeader="false"
    :linea="false"
  >
    <Spinner class="position" :clase="false" v-if="loading" />
    <div class="closeModal-container">
      <img
        @click="handleCerrar"
        class="hide-movil"
        src="@/assets/imgs/icons/icono-cerrarModal.svg"
      />
    </div>
    <h3 class="title">Editar cita</h3>
    <div class="form-container">
      <div class="body-container">
        <input
          placeholder="Nombre"
          v-model="nombre"
          class="input"
          type="text"
        />
        <input
          placeholder="Apellido Paterno"
          v-model="apellido"
          class="input"
          type="text"
        />
        <input
          placeholder="Apellido Materno"
          v-model="segundoApellido"
          class="input"
          type="text"
        />
        <div>
          <input
            @blur="validateCel"
            placeholder="Celular"
            class="input"
            v-model="celular"
            type="text"
          />
          <p v-if="showErrorCel" class="mensajeError">Deben ser 10 dígitos</p>
        </div>
        <div class="select-container">
        <DropdownDate
          @fecha="getDate"
          :minDate="fechaHoy"
          :placeholder="getPlaceHolder"
          id="dropdown"
          :maxWidth="true"
          class="select-item"
        />
        <Dropdown
          @status="getItem"
          :items="hourOptions"
          id="dropdown"
          :maxWidth="true"
          class="select-item"
          :startValue="cliente.hour"
        />
      </div>
      </div>
      <div class="btns-container">
        <button @click="handleRegresar" class="btn-regresar">Cancelar</button>
        <button @click="registrar" :disabled="disabled" class="btn-registrar">
          Guardar cambios
        </button>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from "../Modales/Modal.vue";
import { validateNoErrors } from "../../helpers/helpers";
import appoinmentsService from "../../services/appoinmentService";
import Spinner from "../Loaders/spinner.vue";
import ModalError from '../Modales/ModalError.vue';
import DropdownDate from "../Dropdowns/DropdownDate.vue";
import Dropdown from "../Dropdowns/Dropdown.vue";
import moment from "moment";
export default {
  components: {
    Modal,
    Spinner,
    ModalError,
    Dropdown,
    DropdownDate
  },
  emits: ["cerrar","exito"],
  props:{
    cliente:{
        type:Object,
        default:()=>{},
        required:true
    }
  },
  data() {
    return {
      nombre: "",
      apellido: "",
      segundoApellido: "",
      celular: "",
      showErrorCel: false,
      showModalError:false,
      mensajeError:"",
      loading: false,
      fecha:'',
      hour:0,
      hourOptions: [
        { value: 9, text: "9:00 AM" },
        { value: 10, text: "10:00 AM" },
        { value: 11, text: "11:00 AM" },
        { value: 12, text: "12:00 PM" },
        { value: 13, text: "01:00 PM" },
        { value: 14, text: "02:00 PM" },
        { value: 15, text: "03:00 PM" },
        { value: 16, text: "04:00 PM" },
        { value: 17, text: "05:00 PM" },
        { value: 18, text: "06:00 PM" },
        { value: 19, text: "07:00 PM" },
      ],
    };
  },
  methods: {
    fillData(){
      console.log(this.cliente)
      if(this.cliente?.status){
        const {name,first_lastname,second_lastname,telephones} = this.cliente.clients
        this.nombre = name
        this.apellido = first_lastname
        this.segundoApellido = second_lastname
        this.celular = telephones[0]
        this.fecha = this.cliente?.date
      }else{
        return
      }
    },
    formatDate(fecha){
        const meses = ["ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO", "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"]
        const [año,mes,dia] = fecha.split("-")
        console.log(año)
        const indice = Number(mes) - 1
        return `${dia} ${meses[indice]}`
      },
    handleCerrar() {
      this.$emit("cerrar");
    },
    getDate(fecha){
      this.fecha = fecha
    },
    getItem(value){
      this.hour = value
    },
    cerrarModalError(){
        this.showModalError = false
    },
    handleRegresar() {
      this.$emit("cerrar");
    },
    async registrar() {
      try {
        this.loading = true;
        const data = {
          id:this.cliente._id,
          name: this.nombre,
          first_lastname: this.apellido,
          second_lastname: this.segundoApellido,
          telephones: this.celular,
          fecha: this.fecha,
          hora: this.hour,
        };
       await appoinmentsService.updateAppoinment(data);
        this.loading = false;
        this.$emit("exito","Los cambios han sido guardados con éxito.")
      } catch (error) {
        console.log(error);
        this.loading = false;
        this.showModalError = true
        this.mensajeError = error.data?.message || "Ocurrio un error al modificar la cita"
      }
    },

    validateCel() {
      const telefonoValido = validateNoErrors("telephones", this.celular);
      telefonoValido ? (this.showErrorCel = false) : (this.showErrorCel = true);
    },
    handleDisabled() {
      const telefonoValido = validateNoErrors("telephones", this.celular);
      if (telefonoValido) this.showErrorCel = false;
      if (this.nombre != "" && this.apellido != "" && telefonoValido && this.fecha && this.hour)
          return false;
      return true;
    },
  },
  computed: {
    fechaHoy(){
      return moment().format("YYYY-MM-DD")
    },
    disabled() {
      return this.handleDisabled();
    },
    getPlaceHolder(){
      return this.cliente?.date ? this.formatDate(this.cliente?.date) : "Fecha"
    }
  },
  mounted(){
    this.fillData()
  }
};
</script>

<style scoped>
.closeModal-container {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin-top: 10px;
}

.select-container {
  width: 100%;
  display: grid;
  grid-template-columns: 48.5% 48.5%;
  column-gap: 18px;
}

.select-item {
  width: 100%;
  align-self: center;
  justify-self: center;
}

.btns-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0 30px 0;
}
.btn-regresar {
  width: 172px;
  height: 22px;
  text-align: center;
  font: normal normal bold 16px/22px Open Sans;
  letter-spacing: 0px;
  color: #4caf50;
}
.btn-registrar {
  width: 172px;
  text-align: center;
  height: 40px;
  background: #4caf50 0% 0% no-repeat padding-box;
  border-radius: 4px;
  color: #fff;
}

.btn-registrar:disabled {
  opacity: 0.5;
  cursor: no-drop;
}

.title {
  font: normal normal bold 20px/27px Open Sans;
  letter-spacing: 0px;
  color: #0a4f9c;
  margin-bottom: 10px;
}

.input {
  width: 100%;
  height: 40px;
  background: #ffffff 0% 0% no-repeat padding-box;
  border: 1px solid #afafaf;
  border-radius: 4px;
  padding-left: 7px;
  font: normal normal normal 16px/22px Open Sans;
  letter-spacing: 0px;
  color: #616161;
}

.input::placeholder {
  opacity: 0.5;
}

.mensajeError {
  height: min-content;
  margin: 0;
  margin-top: 5px;
  color: #ff3737;
}

.position {
  position: absolute;
  top: 0;
  left: 0;
}

.body-container {
  height: 350px;
  width: 500px;
  display: grid;
  grid-template-columns: 100%;
  grid-template-rows: auto;
  row-gap: 15px;
  padding: 10px 0px;
}

.hide-movil {
  cursor: pointer;
}

@media screen and (max-width: 767px) {
  .hide-movil {
    display: none;
  }

  .body-container {
    width: 100%;
  }
  .form-container {
    height: 100vh;
  }

  .btns-container {
    margin-top: 140px;
  }

  .title {
    margin-top: 20px;
  }
}
</style>
